import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import IconButton from '../ui-components/IconButton';
import { translateNumber } from 'flow/utils/browser-utils';
import useLongPress from 'flow/hooks/useLongPress';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
var letters = [' ',
// non-breaking space
'A B C', 'D E F', 'G H I', 'J K L', 'M N O', 'P Q R S', 'T U V', 'W X Y Z', null, '+', null];
var Keypad = function Keypad(_ref) {
  var onClick = _ref.onClick,
    value = _ref.value;
  var queryVal = value || '';
  var onLongPress = useLongPress(function () {
    onClick(queryVal + '+');
  }, {
    onStart: function onStart() {
      onClick(queryVal + '0');
    }
  });
  return /*#__PURE__*/_jsx("div", {
    className: "grid grid-cols-[repeat(3,3rem)] justify-center gap-3",
    children: keys.map(function (item, index) {
      var isZero = item === '0';
      return /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({
        dataTestId: "keypad-".concat(item),
        className: "size-12 flex-col rounded-xl bg-gray-200"
      }, isZero ? onLongPress : {}), {}, {
        onClick: isZero ? undefined : function () {
          return onClick(queryVal + item);
        },
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "text-sm/3",
            children: translateNumber(item)
          }), /*#__PURE__*/_jsx("div", {
            className: "text-[0.6rem] leading-4 text-gray-500",
            children: letters[index]
          })]
        })
      }), item);
    })
  });
};
export default Keypad;